import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-my-joined-organisations',
  templateUrl: './my-joined-organisations.component.html',
  styleUrls: ['./my-joined-organisations.component.scss']
})
export class MyJoinedOrganisationsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
